import setExperimentVariant from 'root/src/client/logic/app/actions/setExperimentVariant'

export default experimentVariant => (dispatch) => {
	dispatch(setExperimentVariant(experimentVariant))
}
